import React, { useState, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import heatmap from 'highcharts/modules/heatmap';
import exporting from 'highcharts/modules/exporting';
import exportingOffline from 'highcharts/modules/offline-exporting';
import { DimensionNames } from '../../../../Constants/DimensionNames';
import { generateChartOptions } from './TrendsChartUtils';
import { capitalizeFirstWordOnly } from "../../../../Utility/SharedUtility";
import { Badge } from '@mds/mds-reactjs-library'

heatmap(Highcharts);
exporting(Highcharts);
exportingOffline(Highcharts);

const ProductLevelVolumeAndRevenueGrowthTrends = ({ chart, chartData, chartRef, selectedAttributeNamesByDimension, scale }) => {
  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {
    if (!chartData) return;

    const chartTitle = `${capitalizeFirstWordOnly(selectedAttributeNamesByDimension[DimensionNames.MetricID][0])} growth trends`;
    const chartSubtitle = `${selectedAttributeNamesByDimension[DimensionNames.ConversionID][0]}, bn, ${selectedAttributeNamesByDimension[DimensionNames.CountryID][0]}`;
    const customTooltipConfig = {
      headerFormat: '<b>{category}</b><br/>',
      pointFormat: '{series.name}: <b>{point.y}</b><br/>Total: <b>{point.stackTotal}</b>',
    };
    const options = generateChartOptions(chartData, selectedAttributeNamesByDimension, 'column', chartTitle, chartSubtitle, scale, customTooltipConfig);
    setChartOptions(options);
  }, [chartData, selectedAttributeNamesByDimension]);

  return (
    <div className="highchart">
      {chartData && chartOptions ? (
        <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={chartRef} />
      ) : (
        <div style={{ position: 'relative' }}>
          <img
            style={{ opacity: 0.3, width: '100%' }}
            src={chart?.preview || (chart && `data:${chart?.thumbnailMimetype};base64,${chart?.thumbnail}`)}
            alt={chart?.title || ""}
          />
          <Badge style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '120px',
            height: '40px',
            fontSize: '16px',
            transform: 'translate(-50%, -50%) rotate(0deg)',
            background: '#B3B3B3',
            color: '#333'
          }}>PREVIEW</Badge>
        </div>
      )}
    </div>
  );
};

export default ProductLevelVolumeAndRevenueGrowthTrends;